/**
 * GET /lessons/club/:clubId/availability — when an instructor is free, and in
 * which bays. The lesson flow's own read: the shared availability endpoints
 * resolve only the standard and demo flows.
 *
 * Thin pass-through: returns the envelope unchanged
 * (docs/conventions/internalapi-envelope.md). The chain is tenant-only, so
 * `X-Tenant-Id` is mandatory and a club outside the tenant answers 404.
 *
 * @module lessons/api/getLessonAvailability
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { ApiLessonAvailability, GetLessonAvailabilityParams } from '../types';

export function getLessonAvailability(
  params: GetLessonAvailabilityParams,
): Promise<ApiResult<ApiLessonAvailability>> {
  const query = new URLSearchParams({
    instructorId: String(params.instructorId),
    date: params.date,
    durations: params.durations.join(','),
    slotInterval: String(params.slotInterval),
  });
  return apiClient.get<ApiLessonAvailability>(
    `/lessons/club/${params.clubId}/availability?${query.toString()}`,
    { clubId: params.clubId, tenantHandle: params.tenantHandle },
  );
}
